(() => {
  const doc = document;
  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));
  const safeURL = (value = '') => {
    try {
      const url = new URL(String(value), window.location.origin);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return '#';
      return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : url.href;
    } catch (_) { return '#'; }
  };

  const money = (cents, currency, locale) => {
    try {
      return new Intl.NumberFormat(locale || 'fr-FR', { style: 'currency', currency: currency || 'MAD' }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return `${((Number(cents) || 0) / 100).toFixed(2)} ${currency || 'MAD'}`;
    }
  };

  const closeMobileMenu = () => {
    const nav = doc.querySelector('[data-mobile-nav]');
    const toggle = doc.querySelector('[data-mobile-toggle]');
    if (!nav || !toggle) return;
    nav.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Ouvrir le menu');
    doc.body.classList.remove('is-menu-open');
  };

  const configureFooterAccordions = () => {
    const mobile = window.matchMedia('(max-width: 899px)').matches;
    doc.querySelectorAll('.footer-column').forEach((details) => {
      if (mobile && !details.dataset.userToggled) details.open = false;
      if (!mobile) details.open = true;
    });
  };

  doc.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-mobile-toggle]');
    if (toggle) {
      const nav = doc.querySelector('[data-mobile-nav]');
      if (!nav) return;
      const willOpen = nav.hidden;
      nav.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', String(willOpen));
      toggle.setAttribute('aria-label', willOpen ? 'Fermer le menu' : 'Ouvrir le menu');
      doc.body.classList.toggle('is-menu-open', willOpen);
      if (willOpen) nav.querySelector('a')?.focus({ preventScroll: true });
      return;
    }

    const mobileLink = event.target.closest('a.mobile-nav__link, .mobile-nav__sublink, .mobile-nav__view-all');
    if (mobileLink) closeMobileMenu();

    const footerSummary = event.target.closest('.footer-column summary');
    if (footerSummary) footerSummary.parentElement.dataset.userToggled = 'true';

    const thumb = event.target.closest('[data-media-target]');
    if (thumb) {
      const gallery = thumb.closest('[data-product-gallery]');
      if (!gallery) return;
      const mediaId = thumb.dataset.mediaTarget;
      gallery.querySelectorAll('[data-media-id]').forEach((slide) => {
        const active = slide.dataset.mediaId === mediaId;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      gallery.querySelectorAll('[data-media-target]').forEach((item) => {
        const active = item === thumb;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      return;
    }

    const minus = event.target.closest('[data-quantity-minus]');
    const plus = event.target.closest('[data-quantity-plus]');
    if (minus || plus) {
      const selector = event.target.closest('[data-quantity-selector]');
      const input = selector?.querySelector('input');
      if (!input) return;
      const minimum = Math.max(1, Number(input.min) || 1);
      const current = Math.max(minimum, Number(input.value) || minimum);
      input.value = minus ? Math.max(minimum, current - 1) : current + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const mobileAdd = event.target.closest('[data-mobile-add]');
    if (mobileAdd) {
      const form = doc.querySelector('[data-product-form]');
      const submit = form?.querySelector('[data-add-to-cart]');
      if (submit && !submit.disabled) submit.click();
    }
  });

  doc.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && doc.body.classList.contains('is-menu-open')) {
      closeMobileMenu();
      doc.querySelector('[data-mobile-toggle]')?.focus();
    }
  });

  doc.addEventListener('change', (event) => {
    const sort = event.target.closest('[data-sort-select]');
    if (sort?.form) {
      sort.form.submit();
      return;
    }

    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const root = select.closest('[data-product-root]');
    const option = select.options[select.selectedIndex];
    if (!root || !option) return;

    const price = Number(option.dataset.price || 0);
    const compare = Number(option.dataset.compare || 0);
    const available = option.dataset.available === 'true';
    const mediaId = option.dataset.mediaId;
    const currency = root.dataset.currency || 'MAD';
    const locale = root.dataset.locale || 'fr-FR';

    root.querySelectorAll('[data-product-price]').forEach((el) => { el.textContent = money(price, currency, locale); });
    const compareNode = root.querySelector('[data-product-compare]');
    if (compareNode) {
      compareNode.textContent = money(compare, currency, locale);
      compareNode.hidden = !(compare > price);
    }

    const button = root.querySelector('[data-add-to-cart]');
    const buttonText = root.querySelector('[data-add-to-cart-text]');
    if (button) button.disabled = !available;
    if (buttonText) buttonText.textContent = available ? 'Ajouter au panier' : 'Épuisé';

    const mobileButton = doc.querySelector('[data-mobile-add]');
    const mobileButtonText = doc.querySelector('[data-mobile-add-text]');
    const mobilePrice = doc.querySelector('[data-mobile-product-price]');
    if (mobileButton) mobileButton.disabled = !available;
    if (mobileButtonText) mobileButtonText.textContent = available ? 'Ajouter au panier' : 'Épuisé';
    if (mobilePrice) mobilePrice.textContent = money(price, currency, locale);

    if (mediaId) root.querySelector(`[data-media-target="${CSS.escape(mediaId)}"]`)?.click();

    const url = new URL(document.URL);
    url.searchParams.set('variant', select.value);
    window.history.replaceState({}, '', url);
  });

  const loadRecommendations = (scope = doc) => {
    scope.querySelectorAll('[data-recommendations-root][data-url]:not([data-loaded])').forEach((container) => {
      container.dataset.loaded = 'true';
      fetch(container.dataset.url)
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.text();
        })
        .then((html) => {
          const wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          const fresh = wrapper.querySelector('[data-recommendations-root]');
          if (fresh?.innerHTML.trim()) container.innerHTML = fresh.innerHTML;
          else container.remove();
        })
        .catch(() => container.remove());
    });
  };

  configureFooterAccordions();
  loadRecommendations();
  window.addEventListener('resize', configureFooterAccordions, { passive: true });

  doc.addEventListener('shopify:section:load', (event) => {
    closeMobileMenu();
    configureFooterAccordions();
    loadRecommendations(event.target);
  });


  // Predictive search
  const searchPanel = doc.querySelector('[data-predictive-search]');
  const searchInput = doc.querySelector('[data-predictive-input]');
  const searchResults = doc.querySelector('[data-predictive-results]');
  let searchTimer;
  const closeSearch = () => { if (!searchPanel) return; searchPanel.hidden = true; doc.body.classList.remove('is-search-open'); doc.querySelector('[data-search-toggle]')?.setAttribute('aria-expanded','false'); };
  doc.addEventListener('click', (event) => {
    if (event.target.closest('[data-search-toggle]')) { if(searchPanel){ searchPanel.hidden=false; doc.body.classList.add('is-search-open'); doc.querySelector('[data-search-toggle]')?.setAttribute('aria-expanded','true'); setTimeout(()=>searchInput?.focus(),30);} return; }
    if (event.target.closest('[data-search-close]')) { closeSearch(); return; }
  });
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const q = searchInput.value.trim();
    if (q.length < 2) { searchResults.innerHTML=''; return; }
    searchTimer=setTimeout(async()=>{
      try{
        const url=`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
        const data=await fetch(url).then(r=>r.json());
        const items=data?.resources?.results?.products||[];
        const escapeHTML=(value='')=>String(value).replace(/[&<>'"]/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;',"\"":'&quot;'}[char]));
        const formatSearchPrice=(value)=>{
          const text=String(value||'').replace(/\s+/g,' ').trim();
          const numeric=text.match(/[0-9]+(?:[.,][0-9]{1,2})?/);
          if(!numeric) return text;
          const amount=Number(numeric[0].replace(',','.'));
          if(Number.isNaN(amount)) return text;
          return `${amount.toLocaleString('fr-MA',{minimumFractionDigits:2,maximumFractionDigits:2})} DH`;
        };
        const cards=items.map(p=>`<a class="predictive-item" href="${escapeHTML(p.url)}"><span class="predictive-item__media"><img src="${escapeHTML(p.image||'')}" alt="${escapeHTML(p.title)}" loading="lazy"></span><span class="predictive-item__content"><strong>${escapeHTML(p.title)}</strong><small>${escapeHTML(formatSearchPrice(p.price))}</small></span></a>`).join('');
        const allResults=`<a class="predictive-search__all" href="/search?q=${encodeURIComponent(q)}&type=product">Voir tous les résultats pour « ${escapeHTML(q)} » →</a>`;
        searchResults.innerHTML=items.length?`${cards}${allResults}`:'<p class="predictive-search__empty">Aucun produit trouvé.</p>';
      }catch(e){ searchResults.innerHTML='<p>Recherche indisponible.</p>'; }
    },220);
  });

  // Wishlist (localStorage)
  const getWishlist=()=>{try{return JSON.parse(localStorage.getItem('simotekWishlist')||'[]')}catch(_){return[]}};
  const setWishlist=(items)=>{localStorage.setItem('simotekWishlist',JSON.stringify(items)); syncWishlist();};
  const syncWishlist=()=>{
    const list=getWishlist();
    doc.querySelectorAll('[data-wishlist-count]').forEach(n=>{n.textContent=list.length;n.hidden=list.length===0});
    doc.querySelectorAll('[data-wishlist-toggle]').forEach(b=>{const active=list.includes(b.dataset.productHandle);b.classList.toggle('is-active',active);b.setAttribute('aria-pressed',String(active));b.textContent=active?'♥':'♡'});
  };
  doc.addEventListener('click',async(event)=>{
    const btn=event.target.closest('[data-wishlist-toggle]');
    if(btn){event.preventDefault();let list=getWishlist();const h=btn.dataset.productHandle;list=list.includes(h)?list.filter(x=>x!==h):[h,...list].slice(0,50);setWishlist(list);return;}
    if(event.target.closest('[data-wishlist-open]')){event.preventDefault();await renderWishlist();doc.querySelector('[data-wishlist-drawer]').hidden=false;return;}
    if(event.target.closest('[data-wishlist-close]')){doc.querySelector('[data-wishlist-drawer]').hidden=true;return;}
    const remove=event.target.closest('[data-wishlist-remove]');if(remove){setWishlist(getWishlist().filter(h=>h!==remove.dataset.wishlistRemove));await renderWishlist();}
  });
  const renderWishlist=async()=>{
    const box=doc.querySelector('[data-wishlist-items]');if(!box)return;const list=getWishlist();if(!list.length){box.innerHTML='<p>Aucun favori pour le moment.</p>';return;}
    box.innerHTML='<p>Chargement…</p>';
    const products=(await Promise.all(list.map(h=>fetch(`/products/${h}.js`).then(r=>r.ok?r.json():null).catch(()=>null)))).filter(Boolean);
    box.innerHTML=products.map(p=>`<div class="wishlist-item"><img src="${safeURL(p.featured_image||'')}" alt=""><a href="${safeURL(p.url)}"><strong>${escapeHTML(p.title)}</strong><br><small>${(p.price/100).toLocaleString('fr-MA',{minimumFractionDigits:2,maximumFractionDigits:2})} DH</small></a><button data-wishlist-remove="${escapeHTML(p.handle)}" aria-label="Supprimer">×</button></div>`).join('');
  };
  syncWishlist();

  // Quick view
  const quickModal=doc.querySelector('[data-quick-view-modal]');
  doc.addEventListener('keydown',(event)=>{
    if(event.key!=='Escape')return;
    closeSearch();
    if(quickModal)quickModal.hidden=true;
    const drawer=doc.querySelector('[data-wishlist-drawer]');if(drawer)drawer.hidden=true;
  });
  doc.addEventListener('click',async(event)=>{
    const qv=event.target.closest('[data-quick-view]');
    if(qv){event.preventDefault();const content=doc.querySelector('[data-quick-view-content]');if(!quickModal||!content)return;quickModal.hidden=false;content.innerHTML='<p>Chargement…</p>';try{const p=await fetch(`/products/${qv.dataset.productHandle}.js`).then(r=>{if(!r.ok)throw new Error('product');return r.json()});const first=p.variants.find(v=>v.available)||p.variants[0];const options=p.variants.length>1?`<label for="QuickVariant">Variante</label><select id="QuickVariant" class="quick-view__variant">${p.variants.map(v=>`<option value="${v.id}" data-price="${v.price}" data-available="${v.available}" ${v.id===first.id?'selected':''}>${escapeHTML(v.title)}${v.available?'':' — Épuisé'}</option>`).join('')}</select>`:'';content.innerHTML=`<div class="quick-view__grid"><img src="${safeURL(p.featured_image||'')}" alt="${escapeHTML(p.title)}"><div><p class="eyebrow">${escapeHTML(p.vendor||'SIMOTEK')}</p><h2>${escapeHTML(p.title)}</h2><div class="quick-view__price" data-qv-price>${(first.price/100).toLocaleString('fr-MA',{maximumFractionDigits:0})} DH</div>${options}<p class="quick-view__status ${first.available?'':'is-soldout'}" data-qv-status>${first.available?'En stock':'Épuisé'}</p><div class="quick-view__actions"><a class="btn btn--outline" href="${safeURL(p.url)}">Voir le produit</a><form method="post" action="/cart/add"><input type="hidden" name="id" value="${first.id}" data-qv-id><button class="btn" type="submit" data-qv-submit ${first.available?'':'disabled'}>${first.available?'Ajouter au panier':'Épuisé'}</button></form></div><small>Paiement à la livraison partout au Maroc.</small></div></div>`;const select=content.querySelector('.quick-view__variant');select?.addEventListener('change',()=>{const o=select.selectedOptions[0],available=o.dataset.available==='true';content.querySelector('[data-qv-id]').value=o.value;content.querySelector('[data-qv-price]').textContent=`${(Number(o.dataset.price)/100).toLocaleString('fr-MA',{maximumFractionDigits:0})} DH`;const status=content.querySelector('[data-qv-status]');status.textContent=available?'En stock':'Épuisé';status.classList.toggle('is-soldout',!available);const submit=content.querySelector('[data-qv-submit]');submit.disabled=!available;submit.textContent=available?'Ajouter au panier':'Épuisé';});}catch(_){content.innerHTML='<p>Impossible de charger ce produit.</p>';}return;}
    if(event.target.closest('[data-quick-view-close]')) quickModal.hidden=true;
  });


  // Sticky Add To Cart — desktop top, mobile bottom, only after the main form leaves view
  const stickyBar=doc.querySelector('[data-sticky-buy-bar]');
  const mainProductForm=doc.querySelector('[data-product-form]');
  if(stickyBar&&mainProductForm){
    stickyBar.hidden=false;
    const setSticky=(show)=>{stickyBar.classList.toggle('is-visible',show);doc.body.classList.toggle('has-sticky-buy',show);};
    const observer=new IntersectionObserver(([entry])=>setSticky(!entry.isIntersecting&&entry.boundingClientRect.top<0),{threshold:0});
    observer.observe(mainProductForm);
    stickyBar.querySelector('[data-sticky-add]')?.addEventListener('click',()=>mainProductForm.requestSubmit());
  }

  // Recently viewed
  const currentProductNode=doc.querySelector('[data-current-product]');
  if(currentProductNode){
    try{const current=JSON.parse(currentProductNode.textContent);let recent=JSON.parse(localStorage.getItem('simotekRecentlyViewed')||'[]').filter(p=>p.handle!==current.handle);recent.unshift(current);recent=recent.slice(0,8);localStorage.setItem('simotekRecentlyViewed',JSON.stringify(recent));const older=recent.filter(p=>p.handle!==current.handle).slice(0,4);const section=doc.querySelector('[data-recently-viewed-section]');const grid=doc.querySelector('[data-recently-viewed-grid]');if(section&&grid&&older.length){grid.innerHTML=older.map(p=>`<div role="listitem"><article class="product-card"><a class="product-card__link" href="${safeURL(p.url)}"><div class="product-media"><img loading="lazy" src="${safeURL(p.image)}" alt="${escapeHTML(p.title)}"></div><div class="product-info"><div class="product-vendor">${escapeHTML(p.vendor||'')}</div><h3 class="product-title">${escapeHTML(p.title)}</h3><div class="product-price-row"><span class="price">${escapeHTML(p.price)}</span></div></div></a></article></div>`).join('');section.hidden=false;}}
    catch(_){ }
  }


  // Premium horizontal product carousels — recently viewed and related products
  doc.addEventListener('click', (event) => {
    const control = event.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!control) return;
    const section = control.closest('section');
    const track = section?.querySelector('.product-carousel__track');
    if (!track) return;
    const item = track.querySelector(':scope > *');
    const gap = Number.parseFloat(getComputedStyle(track).gap) || 16;
    const distance = item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
    const step = control.hasAttribute('data-carousel-next') ? distance : -distance;
    track.scrollBy({ left: step * direction, behavior: 'smooth' });
  });

  // Cart upsell — Shopify product recommendations (complementary, then related fallback)
  const loadCartUpsell = async (intent = 'complementary') => {
    const loader = doc.querySelector('[data-cart-upsell-loader]');
    if (!loader) return;
    const productId = loader.dataset.productId;
    const sectionId = loader.dataset.sectionId;
    if (!productId || !sectionId) return;
    try {
      const url = `/recommendations/products?section_id=${encodeURIComponent(sectionId)}&product_id=${encodeURIComponent(productId)}&limit=4&intent=${intent}`;
      const html = await fetch(url).then(r => { if (!r.ok) throw new Error('upsell'); return r.text(); });
      const wrap = document.createElement('div');
      wrap.innerHTML = html;
      const fresh = wrap.querySelector('[data-cart-upsell-section]');
      const grid = fresh?.querySelector('.cart-upsell__grid');
      if (grid && grid.children.length) {
        doc.querySelector('[data-cart-upsell-section]')?.replaceWith(fresh);
      } else if (intent === 'complementary') {
        await loadCartUpsell('related');
      } else {
        doc.querySelector('[data-cart-upsell-section]')?.remove();
      }
    } catch (_) {
      if (intent === 'complementary') loadCartUpsell('related');
      else doc.querySelector('[data-cart-upsell-section]')?.remove();
    }
  };
  loadCartUpsell();

  doc.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-upsell-add]');
    if (!button || button.disabled) return;
    button.disabled = true;
    const original = button.textContent;
    button.textContent = 'Ajout…';
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items:[{id:Number(button.dataset.variantId),quantity:1}]})
      });
      if (!response.ok) throw new Error('add');
      button.textContent = 'Ajouté ✓';
      setTimeout(() => window.location.reload(), 450);
    } catch (_) {
      button.disabled = false;
      button.textContent = original;
    }
  });

})();

/* SIMOTEK touch behaviour: first tap reveals clean product actions; second tap follows the product link. */
(() => {
  const coarsePointer = window.matchMedia('(hover: none), (pointer: coarse)');
  document.addEventListener('click', (event) => {
    if (!coarsePointer.matches) return;
    const action = event.target.closest('.product-card__action, .product-card__wishlist, .product-card__add-form');
    if (action) return;
    const card = event.target.closest('[data-product-card]');
    if (!card) {
      document.querySelectorAll('.product-card.is-actions-visible').forEach((item) => item.classList.remove('is-actions-visible'));
      return;
    }
    const link = event.target.closest('.product-card__link');
    if (link && !card.classList.contains('is-actions-visible')) {
      event.preventDefault();
      document.querySelectorAll('.product-card.is-actions-visible').forEach((item) => {
        if (item !== card) item.classList.remove('is-actions-visible');
      });
      card.classList.add('is-actions-visible');
    }
  });
})();


/* SIMOTEK 3.0.3 — Mobile categories automatic infinite loop.
   Keeps native touch scrolling and pauses briefly after user interaction. */
(() => {
  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');
  const AUTOPLAY_DELAY = 2800;
  const RESUME_DELAY = 5000;

  const setupCategoryLoop = (track) => {
    if (!track || track.dataset.loopReady === 'true') return;

    let originals = Array.from(track.children).filter((item) => !item.dataset.loopClone);
    if (originals.length < 2) return;

    track.dataset.loopReady = 'true';
    let autoplayTimer = null;
    let resumeTimer = null;
    let scrollTimer = null;
    let cycleWidth = 0;

    const removeClones = () => {
      track.querySelectorAll('[data-loop-clone]').forEach((clone) => clone.remove());
      cycleWidth = 0;
    };

    const createClones = () => {
      removeClones();
      originals = Array.from(track.children).filter((item) => !item.dataset.loopClone);
      originals.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.dataset.loopClone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((node) => {
          node.setAttribute('tabindex', '-1');
        });
        if (clone.matches('a, button, input, select, textarea, [tabindex]')) clone.setAttribute('tabindex', '-1');
        track.appendChild(clone);
      });

      const firstClone = track.querySelector('[data-loop-clone]');
      const firstOriginal = originals[0];
      if (firstClone && firstOriginal) cycleWidth = firstClone.offsetLeft - firstOriginal.offsetLeft;
    };

    const normalizePosition = () => {
      if (!cycleWidth) return;
      if (track.scrollLeft >= cycleWidth - 2) {
        track.scrollTo({ left: track.scrollLeft - cycleWidth, behavior: 'auto' });
      }
    };

    const cardStep = () => {
      const first = originals[0];
      if (!first) return track.clientWidth * 0.82;
      const styles = getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 12;
      return first.getBoundingClientRect().width + gap;
    };

    const stopAutoplay = () => {
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (!MOBILE_QUERY.matches || document.hidden || !cycleWidth) return;
      autoplayTimer = window.setInterval(() => {
        normalizePosition();
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      }, AUTOPLAY_DELAY);
    };

    const pauseThenResume = () => {
      stopAutoplay();
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(startAutoplay, RESUME_DELAY);
    };

    const enable = () => {
      if (!MOBILE_QUERY.matches) {
        stopAutoplay();
        removeClones();
        track.scrollTo({ left: 0, behavior: 'auto' });
        return;
      }
      createClones();
      track.scrollTo({ left: 0, behavior: 'auto' });
      startAutoplay();
    };

    track.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(normalizePosition, 140);
    }, { passive: true });

    ['pointerdown', 'touchstart', 'wheel'].forEach((eventName) => {
      track.addEventListener(eventName, pauseThenResume, { passive: true });
    });

    track.addEventListener('focusin', pauseThenResume);
    track.addEventListener('mouseenter', stopAutoplay);
    track.addEventListener('mouseleave', startAutoplay);
    document.addEventListener('visibilitychange', () => document.hidden ? stopAutoplay() : startAutoplay());

    let resizeTimer = null;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(enable, 180);
    }, { passive: true });

    if (typeof MOBILE_QUERY.addEventListener === 'function') MOBILE_QUERY.addEventListener('change', enable);
    else MOBILE_QUERY.addListener(enable);

    enable();
  };

  const initCategoryLoops = (root = document) => {
    root.querySelectorAll('[data-category-loop]').forEach(setupCategoryLoop);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initCategoryLoops());
  else initCategoryLoops();

  document.addEventListener('shopify:section:load', (event) => initCategoryLoops(event.target));
})();

/* SIMOTEK 3.0.22 — Final homepage predictive product search polish. */
(() => {
  const SELECTOR = '[data-home-predictive-search]';

  const escapeText = (value) => String(value ?? '');

  const normalizePrice = (value, currency, locale) => {
    if (value === null || value === undefined || value === '') return '';
    const cleaned = String(value).replace(/[^0-9.,-]/g, '').replace(',', '.');
    const number = Number(cleaned);
    if (!Number.isFinite(number)) return String(value);
    try {
      return new Intl.NumberFormat(locale || 'fr-FR', {
        style: 'currency',
        currency: currency || 'MAD',
        maximumFractionDigits: 2
      }).format(number);
    } catch (_) {
      return `${number.toFixed(2)} ${currency || 'MAD'}`;
    }
  };

  const initHomePredictiveSearch = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((section) => {
      if (section.dataset.predictiveSearchReady === 'true') return;
      section.dataset.predictiveSearchReady = 'true';

      const form = section.querySelector('[data-home-search-form]');
      const input = section.querySelector('[data-home-search-input]');
      const results = section.querySelector('[data-home-search-results]');
      if (!form || !input || !results) return;

      const predictiveUrl = section.dataset.searchUrl || '/search/suggest';
      const resultsUrl = section.dataset.resultsUrl || '/search';
      const locale = section.dataset.locale || document.documentElement.lang || 'fr-FR';
      const currency = section.dataset.currency || 'MAD';
      const limit = Math.max(3, Math.min(10, Number(section.dataset.limit) || 6));
      const labels = {
        loading: section.dataset.loadingLabel || 'Recherche en cours…',
        empty: section.dataset.emptyLabel || 'Aucun produit trouvé.',
        error: section.dataset.errorLabel || 'Impossible de charger les suggestions.',
        viewAll: section.dataset.viewAllLabel || 'Voir tous les résultats',
        inStock: section.dataset.inStockLabel || 'En stock',
        unavailable: section.dataset.unavailableLabel || 'Indisponible',
        view: section.dataset.viewLabel || 'Voir'
      };

      let debounceTimer = null;
      let controller = null;
      let activeIndex = -1;

      const getOptions = () => Array.from(results.querySelectorAll('[role="option"]'));

      const setExpanded = (expanded) => {
        input.setAttribute('aria-expanded', String(expanded));
        results.hidden = !expanded;
      };

      const close = () => {
        activeIndex = -1;
        getOptions().forEach((option) => option.setAttribute('aria-selected', 'false'));
        setExpanded(false);
      };

      const showStatus = (message, loading = false) => {
        results.replaceChildren();
        const status = document.createElement('div');
        status.className = 'home-search-results__status';
        status.setAttribute('role', 'status');
        if (loading) {
          const spinner = document.createElement('div');
          spinner.className = 'home-search-results__spinner';
          spinner.setAttribute('aria-hidden', 'true');
          status.appendChild(spinner);
        }
        status.appendChild(document.createTextNode(message));
        results.appendChild(status);
        setExpanded(true);
      };

      const appendHighlightedText = (element, text, query) => {
        const source = escapeText(text);
        const term = escapeText(query).trim();
        if (!term) {
          element.textContent = source;
          return;
        }
        const lowerSource = source.toLocaleLowerCase(locale);
        const lowerTerm = term.toLocaleLowerCase(locale);
        let cursor = 0;
        let matchIndex = lowerSource.indexOf(lowerTerm, cursor);
        while (matchIndex !== -1) {
          if (matchIndex > cursor) element.appendChild(document.createTextNode(source.slice(cursor, matchIndex)));
          const mark = document.createElement('mark');
          mark.textContent = source.slice(matchIndex, matchIndex + term.length);
          element.appendChild(mark);
          cursor = matchIndex + term.length;
          matchIndex = lowerSource.indexOf(lowerTerm, cursor);
        }
        if (cursor < source.length) element.appendChild(document.createTextNode(source.slice(cursor)));
      };

      const createProductOption = (product, index, query) => {
        const link = document.createElement('a');
        link.className = 'home-search-result';
        link.href = product.url || '#';
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');
        link.id = `HomeSearchOption-${section.dataset.sectionId || 'section'}-${index}`;

        const imageWrap = document.createElement('span');
        imageWrap.className = 'home-search-result__image';
        const imageData = product.featured_image || product.image;
        const imageUrl = imageData?.url || imageData?.src || '';
        if (imageUrl) {
          const image = document.createElement('img');
          image.src = imageUrl.includes('?') ? `${imageUrl}&width=160` : `${imageUrl}?width=160`;
          image.alt = escapeText(imageData?.alt || product.title || '');
          image.loading = 'lazy';
          image.width = 80;
          image.height = 80;
          imageWrap.appendChild(image);
        }

        const meta = document.createElement('span');
        meta.className = 'home-search-result__meta';
        const title = document.createElement('span');
        title.className = 'home-search-result__title';
        appendHighlightedText(title, product.title, query);
        meta.appendChild(title);
        if (product.vendor) {
          const vendor = document.createElement('span');
          vendor.className = 'home-search-result__vendor';
          vendor.textContent = escapeText(product.vendor);
          meta.appendChild(vendor);
        }

        const side = document.createElement('span');
        side.className = 'home-search-result__side';

        const availability = document.createElement('span');
        const isAvailable = product.available !== false;
        availability.className = `home-search-result__availability ${isAvailable ? 'is-available' : 'is-unavailable'}`;
        availability.textContent = isAvailable ? labels.inStock : labels.unavailable;

        const price = document.createElement('span');
        price.className = 'home-search-result__price';
        price.textContent = normalizePrice(product.price, currency, locale);

        const view = document.createElement('span');
        view.className = 'home-search-result__view';
        view.textContent = `${labels.view} →`;

        side.append(availability, price, view);
        link.append(imageWrap, meta, side);
        return link;
      };

      const renderProducts = (products, query) => {
        results.replaceChildren();
        if (!products.length) {
          showStatus(labels.empty);
          return;
        }

        const list = document.createElement('div');
        list.className = 'home-search-results__list';
        products.slice(0, limit).forEach((product, index) => list.appendChild(createProductOption(product, index, query)));
        results.appendChild(list);

        const all = document.createElement('a');
        all.className = 'home-search-results__all';
        all.href = `${resultsUrl}?q=${encodeURIComponent(query)}&type=product&options%5Bprefix%5D=last`;
        all.textContent = labels.viewAll;
        results.appendChild(all);
        activeIndex = -1;
        setExpanded(true);
      };

      const requestSuggestions = async (query) => {
        controller?.abort();
        controller = new AbortController();
        showStatus(labels.loading, true);

        const separator = predictiveUrl.includes('?') ? '&' : '?';
        const url = `${predictiveUrl}${separator}q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=${limit}&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag`;

        try {
          const response = await fetch(url, {
            signal: controller.signal,
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const payload = await response.json();
          const products = payload?.resources?.results?.products || [];
          renderProducts(products, query);
        } catch (error) {
          if (error.name === 'AbortError') return;
          showStatus(labels.error);
        }
      };

      input.addEventListener('input', () => {
        window.clearTimeout(debounceTimer);
        const query = input.value.trim();
        if (query.length < 2) {
          controller?.abort();
          close();
          return;
        }
        debounceTimer = window.setTimeout(() => requestSuggestions(query), 240);
      });

      input.addEventListener('focus', () => {
        if (input.value.trim().length >= 2 && results.childElementCount) setExpanded(true);
      });

      input.addEventListener('keydown', (event) => {
        const options = getOptions();
        if (!options.length) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          activeIndex = event.key === 'ArrowDown'
            ? (activeIndex + 1) % options.length
            : (activeIndex - 1 + options.length) % options.length;
          options.forEach((option, index) => option.setAttribute('aria-selected', String(index === activeIndex)));
          input.setAttribute('aria-activedescendant', options[activeIndex].id);
          options[activeIndex].scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'Enter' && activeIndex >= 0) {
          event.preventDefault();
          options[activeIndex].click();
        } else if (event.key === 'Escape') {
          close();
          input.removeAttribute('aria-activedescendant');
        }
      });

      form.addEventListener('submit', (event) => {
        if (!input.value.trim()) event.preventDefault();
      });

      document.addEventListener('click', (event) => {
        if (!section.contains(event.target)) close();
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initHomePredictiveSearch());
  else initHomePredictiveSearch();
  document.addEventListener('shopify:section:load', (event) => initHomePredictiveSearch(event.target));
})();

/* SIMOTEK 3.0.29 — ouvre WhatsApp depuis une carte produit sans perturber Voir/Ajouter. */
(() => {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-card-whatsapp]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const url = button.dataset.whatsappUrl;
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  });
})();
